import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/document/query/', 'Docs');

// tbl.add(new Xtc('time', 'Recorded time').renderSlot('time'))
tbl.add(new Xtc('name', 'Name').renderSlot('names'))
tbl.add(new Xtc('matter', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('tags', 'Tags').renderSlot('tags'))
tbl.add(new Xtc('file_info_count', 'Download count').renderSlot('count').noSort().hidden())
tbl.add(new Xtc('file_info_size', 'Document Size').renderSlot('size').noSort())
tbl.add(new Xtc('file_info_date', 'Upload Date').renderSlot('createdAt').noSort())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

